(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get("id");
    const formContainer = document.querySelector(
      ".identificacion-page__container",
    );

    if (!formContainer) return;

    if (!orderId) {
      formContainer.innerHTML =
        '<div class="identificacion-page__error">Orden desconocida</div>';
      return;
    }

    const form = document.querySelector(".identificacion-page__form");
    const fileInput = document.querySelector("#pdf-upload");
    const submitButton = document.querySelector(".identificacion-page__submit");
    const messageContainer = document.querySelector(
      ".identificacion-page__message",
    );

    if (!form || !fileInput || !submitButton || !messageContainer) return;

    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      const file = fileInput.files[0];
      if (!file) {
        showMessage("Por favor selecciona un archivo PDF", "error");
        return;
      }

      if (file.type !== "application/pdf") {
        showMessage("Por favor selecciona un archivo PDF válido", "error");
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = "Enviando...";

      const formData = new FormData();
      formData.append("file", file);
      formData.append("orderId", orderId);

      try {
        // API endpoint URL to be defined
        const apiUrl =
          "https://triangulum-services.acromatico-development.workers.dev/identificacion"; // Replace with actual API endpoint

        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
          showMessage(data.message || "Archivo subido exitosamente", "success");
          form.reset();
        } else {
          showMessage(data.message || "Error al subir el archivo", "error");
        }
      } catch (error) {
        showMessage("Error de conexión. Por favor intenta de nuevo.", "error");
        console.error("Upload error:", error);
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = "Enviar";
      }
    });

    function showMessage(message, type) {
      messageContainer.textContent = message;
      messageContainer.className =
        "identificacion-page__message identificacion-page__message--" + type;
      messageContainer.style.display = "block";

      setTimeout(() => {
        messageContainer.style.display = "none";
      }, 5000);
    }
  });
})();
